// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1e6f8f3a","513":"7551caa7","703":"e6fdd650","787":"d1ff9d58"}[chunkId] + ".chunk.js";
};